module.exports = __webpack_public_path__ + "fonts/af85b53.woff";